import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const invalidDecimalCheck = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value == null) {
            return null;
        }

        const value = Number(control.value);
        if (isNaN(value)) {
            return { invalidDecimal: true }; // Not a valid number
        }

        // If the field value is = 0 OR the (field value remainder divided by .25 is = 0) the field is valid return null
        if (control.value === 0 || control.value % 0.25 === 0) {
            return null; // Valid value
        } else {
            return { invalidDecimal: true }; // Invalid Value
        }
    };
};
